import styled from 'styled-components'

const StyledCalendar = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

export default StyledCalendar
